export const BASE_URL = 'https://api.rd-trading.net';
// export const BASE_URL = 'https://midad-api.beetronix.net';
// export const BASE_URL = 'https://api.thimartuwaiq.com';

export const INNER_VERSION = '1.17.0';
export const VERSION = '3.2.0';